import React from 'react';
import { X, ArrowRight } from '@phosphor-icons/react';
import axios from 'axios';

// Always use current origin for API calls (works for any domain)
const API = `${window.location.origin}/api`;

export default function NotificationBanner({ notification, onDismiss }) {
    if (!notification) return null;

    const markAsRead = async () => {
        try {
            await axios.put(`${API}/notifications/${notification.id}/read`);
            onDismiss();
        } catch (err) {
            console.error('Error marking as read:', err);
        }
    };

    const openTarget = async () => {
        // Fire-and-forget mark-as-read; navigation must not depend on it
        axios.put(`${API}/notifications/${notification.id}/read`).catch(() => {});
        if (!notification.url) {
            onDismiss?.();
            return;
        }
        try {
            const url = new URL(notification.url, window.location.origin);
            if (url.origin === window.location.origin) {
                window.location.href = url.pathname + url.search + url.hash;
            } else {
                window.open(notification.url, '_blank', 'noopener');
            }
        } catch {
            window.location.href = notification.url;
        }
    };

    return (
        <div className="bg-muted border-l-4 border-foreground p-4 mb-6 rounded-sm shadow-sm animate-in slide-in-from-top">
            <div className="flex items-start gap-3">
                <div className="flex-shrink-0">
                    <div className="w-10 h-10 bg-muted text-foreground rounded-full flex items-center justify-center text-xl">
                        ℹ️
                    </div>
                </div>
                <div className="flex-1 min-w-0">
                    <h4 className="font-semibold text-blue-900 mb-1">Nowe powiadomienie</h4>
                    <p className="text-sm text-blue-800">{notification.message}</p>
                    <div className="flex gap-2 mt-3">
                        {notification.url && (
                            <button
                                onClick={openTarget}
                                className="text-sm px-3 py-1.5 bg-blue-600 text-white hover:bg-blue-700 rounded-sm flex items-center gap-1.5"
                                data-testid="notification-banner-open"
                            >
                                Otwórz <ArrowRight className="w-3.5 h-3.5" weight="bold" />
                            </button>
                        )}
                        <button
                            onClick={markAsRead}
                            className="text-sm px-3 py-1.5 text-foreground hover:bg-muted rounded-sm"
                        >
                            Zamknij
                        </button>
                    </div>
                </div>
                <button
                    onClick={onDismiss}
                    className="flex-shrink-0 p-1 hover:bg-muted rounded-sm text-foreground"
                >
                    <X className="w-5 h-5" />
                </button>
            </div>
        </div>
    );
}
